import styled from "styled-components";

const Errors = styled.div`
  width: 100%;
`;

export { Errors };
